jQuery(document).ready(function(){
    $('.owl-carousel').owlCarousel({
    	nav: true,
        dots: false,
        loop: true,
        items: 1,
        puaseOnHover: true,
        autoplay: false,
        margin: 10,
        autoHeight:true,
        autoplaySpeed: 3000,
        lazyLoad: true,
        animateOut: 'fadeOut',
        navText: ["<img src='/assets/sea_opt0423-arrow--prev@2x.png'>","<img src='/assets/sea_opt0423-arrow--next@2x.png'>"],
        navContainer: '.custom-nav'
    });
});
